import React, { useEffect } from "react";
export default function WebsiteAILauncher() {
  useEffect(() => {
    window.open("/webcontainer/index.html", "_blank");
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h2 className="text-2xl font-semibold mb-2">
          Website AI Builder
        </h2>
        <p className="text-gray-600">
          Opening in a secure workspace…
        </p>
      </div>
    </div>
  );
}
